import { BedIcon } from './BedIcon';

/**
 * author: Google
 * id EA62EF73-ACC7-4E54-87EF-D5E1683BE58F
 * name bed
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const HotelIcon = BedIcon;
export default HotelIcon